import React, { Component } from 'react';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';
import Logo from '../Logo';

import pick from 'lodash/pick';


import { Modal, ModalBody, Button, Row, Col} from 'reactstrap';
import ModalHeader from '../reactstrap/ModalHeader';

// const mapStateToProps = state => ({currentProject: state.currentProject});
// 
// const matchDispatchToProps = dispatch => {
//   return bindActionCreators({ }, dispatch)
// };

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';

import {
  faArrowToBottom
} from '@fortawesome/pro-regular-svg-icons';

import QRCode from "qrcode";


// const ShareLink  = lazy(() => import('./components/SmartLinks/EditBioLink'));

const modalPropKeys = Object.keys(Modal.propTypes);

class ShareLinkModal extends Component {
  
  constructor (props){
    super(props);
    
    this.state = {
      qrcodeUrl: null,
      qrcodeSvg: null
    }
  }
  
  componentWillMount (){
    const { short_url } = this.props;
    
    const QRparams = {
      errorCorrectionLevel: 'H',
      margin: 0,
      color: {
        dark: '#000',  // dots
        light: '#0000' // Transparent background
      }
    }
    
    QRCode.toDataURL(short_url, {...QRparams, width: 1024}).then((qrcodeUrl) =>{
      this.setState({qrcodeUrl})
    })
    QRCode.toString(short_url, { ...QRparams, type: "svg"}).then((qrcodeSvg) =>{
      this.setState({qrcodeSvg: `data:image/svg+xml,${encodeURIComponent(qrcodeSvg)}`})
    });
  }
  
  
  onSuccess(res) {
    const { toggle } = this.props;
    toggle();
  }
  
  render() {
    const { toggle, short_url, slug, ...otherProps } = this.props;
    const modalProps = pick(otherProps, modalPropKeys);
    
    const { qrcodeUrl, qrcodeSvg } = this.state;
    
    return (qrcodeUrl ?
      <Modal {...modalProps} centered={true}>
        <ModalHeader toggle={toggle} style={{textAlign: 'center'}}>
          <div style={{paddingLeft: '0.625em', fontSize: "0.8em"}}><Logo noclick={true} /></div>
        </ModalHeader>
        
        <ModalBody className="text-center">
          
          <div>{short_url}</div>
          <div><img alt="" src={qrcodeUrl} className="mt-4 qrcode mb-2" width="100%" style={{maxWidth: '200px'}} /></div>
          
          <Row className="mt-4 mb-2" style={{maxWidth: "350px", margin: 'auto'}}>
            <Col xs="6">
              <Button
                color="secondary"
                block={true}
                className="upcase"
                href={qrcodeUrl} download={`shor-${slug}`}
                size="sm"
                outline
              >
                <FA icon={faArrowToBottom} style={{marginTop: "0.1em"}} />  PNG
              </Button>
            </Col>
            <Col xs="6">
              <Button
                color="secondary"
                block={true}
                className="upcase"
                href={qrcodeSvg} download={`shor-${slug}`}
                size="sm"
                outline
              >
                <FA icon={faArrowToBottom} style={{marginTop: "0.1em"}} />  SVG
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    : null);
  }
  
}

export default ShareLinkModal
//export default connect(mapStateToProps, matchDispatchToProps)(ShareLinkModal);


// WEBPACK FOOTER //
// ./src/components/Links/ShareLinkModal.js